var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"rounded-lg text-none font-weight-regular",attrs:{"small":"","color":"grey darken-2 white--text","depressed":""},on:{"click":function($event){return _vm.$emit('click', this)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }